import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MediasState } from '../reducers/medias.reducer';
import { MEDIAS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<MediasState>(MEDIAS_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: MediasState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: MediasState) => state.loading);
export const selectItems = createSelector(selectState, (state: MediasState) => state.items);
export const selectTotal = createSelector(selectState, (state: MediasState) => state.total);
export const selectPage = createSelector(selectState, (state: MediasState) => state.page);
export const selectLimit = createSelector(selectState, (state: MediasState) => state.limit);
export const selectLastParams = createSelector(selectState, (state: MediasState) => state.lastParams);
